/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import { changeLocation } from 'api/Location';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf3.png';

const goToTeamReport = (e, activeRound) => {
  e.preventDefault();

  changeLocation(`/analysis/team-reports?round=${activeRound}`);
}

const GoodLuckStep1 = ({ activeRound }) => (
  <OneVisualLayout
    section="GOOD LUCK!"
    title="See You in the Next Round"
    paragraph2={(
      <Fragment>
        In the next year, you will expect a few changes in the game based on
        current market performances. Don't hesitate to review this performance
        feedback and discuss it with your team before the next round.
        <br /><br />
        Also equally important, don't hesitate to review your <a href="#" onClick={e => goToTeamReport(e, activeRound)}>Team Report</a>, which
        helps you compare your performance in relation to your competitors.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default GoodLuckStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/good-luck/step1.js